module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productlist mobile-product",
    style: (_vm.cardStyle),
    attrs: {
      "id": _vm.product && 'productlist-' + _vm.product.id
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/product/' + this.urlKey + '?gte' + '=' + (this.genderType || 0)
    }
  }, [_c('div', {
    directives: [{
      name: "lazyloadImage",
      rawName: "v-lazyloadImage",
      value: (Object.assign({}, _vm.getTatvicprImpression)),
      expression: "{...getTatvicprImpression}"
    }],
    staticClass: "d-inline-block w-100 custom-border",
    class: 'listhover ' + _vm.pclass,
    on: {
      "click": function($event) {
        _vm.trigerEvent(_vm.index, _vm.parry, _vm.productCat, _vm.renderName, _vm.callerComp)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "imageBackground",
      rawName: "v-imageBackground",
      value: (_vm.isBlockMounted ? '1080:1440' : ''),
      expression: "isBlockMounted ? '1080:1440' : ''"
    }],
    staticClass: "customFade w-100 img-auto",
    attrs: {
      "fallback": "https://tss-static-images.gumlet.io/blankimg.jpg",
      "placeholder": 'https://tss-static-images.gumlet.io/blankimg.jpg',
      "blur": 30,
      "data-url": _vm.parry,
      "alt": (_vm.productTitle + " " + _vm.listCat + " Online"),
      "title": (_vm.productTitle + " " + _vm.listCat + " at The Souled Store"),
      "width": "355",
      "height": "280"
    }
  }), _vm._v(" "), _vm._l((_vm.plpMockUpTags), function(mockUpTag) {
    return _c('div', {
      key: mockUpTag.product_slug,
      staticClass: "mockup-tag",
      class: _vm.getMockUpTagPositionClass(mockUpTag.tag_position)
    }, [(mockUpTag.product_slug === _vm.urlKey && mockUpTag.is_active_plp) ? _c('span', {
      style: ({
        backgroundColor: mockUpTag.background_color,
        color: mockUpTag.text_color
      })
    }, [_vm._v(_vm._s(mockUpTag.tag_name))]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "image-block-details",
    class: {
      'height-membership': _vm.isExclusive
    }
  }, [_c('h5', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.productTitle))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 listprice ecltext",
    staticStyle: {
      "padding-right": "0px"
    },
    attrs: {
      "title": _vm.productCat
    }
  }, [(_vm.listCat) ? _c('span', [_vm._v(_vm._s(_vm.listCat))]) : _c('span', [_vm._v(_vm._s(_vm.productCat))])]), _vm._v(" "), (_vm.productPrice) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [(_vm.getround(_vm.spprice) || (_vm.isExclusive && _vm.getround(_vm.exclusivePrice))) ? _c('span', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 special-products_pricing"
  }, [_c('span', {
    staticClass: "offer fsemibold"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.isExclusive ? _vm.exclusivePrice && _vm.getround(_vm.exclusivePrice) : _vm.spprice && _vm.getround(_vm.spprice)))]), _vm._v(" "), _c('span', {
    staticClass: "product-price",
    staticStyle: {
      "text-decoration": "line-through",
      "color": "#757575"
    }
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.productPrice && _vm.getround(_vm.productPrice)))]), _vm._v(" "), (!_vm.isExclusive && _vm.spprice > 0) ? _c('span', {
    staticClass: "percentage-off"
  }, [(_vm.isNonExclusiveSavingsInPercent) ? _c('span', [_vm._v(_vm._s(((Math.round((_vm.productPrice - (_vm.isExclusive ? _vm.exclusivePrice : _vm.spprice)) / _vm.productPrice * 100)) + "%")) + " " + _vm._s((_vm.nonMemberSavingsTxt && _vm.nonMemberSavingsTxt.tag_text) || 'OFF'))]) : _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(("" + ((_vm.getround(_vm.productPrice) - _vm.getround(_vm.spprice))))) + " " + _vm._s((_vm.nonMemberSavingsTxt && _vm.nonMemberSavingsTxt.tag_text) || 'OFF'))])]) : _vm._e()])])]) : _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.productPrice && _vm.getround(_vm.productPrice)))]), _vm._v(" "), (_vm.showPriceInclusiveOnHome && _vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "mrp-text"
  }, [_vm._v(_vm._s(_vm.showPriceInclusiveOnHome.tag_text))]) : _vm._e(), _vm._v(" "), (_vm.showMrpOnHomeGlobal && !_vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "mrp-text"
  }, [_vm._v(_vm._s(_vm.showMrpOnHomeGlobal.tag_text))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getround(_vm.exclusivePrice) && _vm.getround(_vm.productPrice) && _vm.isExclusive) ? _c('div', {
    staticClass: "col-12 percentage-off member-savings"
  }, [(_vm.isExclusiveSavingsInPercent) ? _c('span', [_vm._v(_vm._s(_vm.getround((_vm.getround(_vm.productPrice) - _vm.getround(_vm.exclusivePrice)) / _vm.getround(_vm.productPrice) * 100)) + "% " + _vm._s((_vm.memberSavingsTxt && _vm.memberSavingsTxt.tag_text) || 'Member Savings'))]) : _c('span', [_vm._v(_vm._s((_vm.memberSavingsTxt && _vm.memberSavingsTxt.tag_text) || 'Member Savings') + " " + _vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.getround(_vm.productPrice) - _vm.getround(_vm.exclusivePrice)))])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForGstInclusiveLabel && Object.keys(_vm.bannerPlaceHolderForGstInclusiveLabel).length) ? _c('div', {
    staticClass: "col-12 gstInclusiveLabel"
  }, [_c('span', {
    style: (("color: " + (_vm.bannerPlaceHolderForGstInclusiveLabel.banner_text_color) + "; background: " + (_vm.bannerPlaceHolderForGstInclusiveLabel.banner_color) + ";"))
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderForGstInclusiveLabel.tag_text))])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff9bbf12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TopSellingImgBlock.vue
// module id = 1368
// module chunks = 5 15 46 54